var safeFetch = require('safe-fetch');

var bus = require('@zalando-internal/z-shop-event-bus');
safeFetch.cookieName = 'frsx';
safeFetch.headerName = 'x-xsrf-token';

module.exports = function (url, optionalOptions) {
    var options = Object.assign({ reportChildRequestId: true }, optionalOptions);
    return safeFetch.apply(safeFetch, arguments).then(function (r) {
        if (r && r.headers && r.headers.get && options.reportChildRequestId) {
            bus.trigger(
                'tracking:child-request-id',
                r.headers.get('x-zalando-child-request-id'),
                url,
                optionalOptions,
            );
        }
        return r;
    });
};
